/**
 * Created by SG0949773 on 10/22/2015.
 */
'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.SystemConfiguration.ConfigurationLegAssignment', ['AVRO.Common.DataRetriever']).controller('ConfigurationLegAssignmentController', require('./controllers/ConfigurationLegAssignmentController')).directive('rmConfigurationLegAssignment', require('./directives/ConfigurationLegAssignmentDirective')).factory('ConfigurationLegAssignmentService', require('./services/ConfigurationLegAssignmentService'));